import React from "react";
// import Header from "./Header";
import heroBanner from "../assets/images/herobanner.png";

const Hero = () => {
  return (
    <div
      className="relative h-screen  w-full"
      style={{ clipPath: "polygon(0% 0, 100% 0%, 100% 100%, 0 100%)" }}
    >
      <img
        src={heroBanner}
        alt="Hero Banner"
        className="inset-0 w-full fixed top-0 h-full object-cover"
      />
      <div className="relative z-10 h-full text-white text-center px-4 bg-black bg-opacity-50">
        <div className=" p-[1px] hidden md:block absolute bottom-0 left-1/2 -translate-x-1/2 w-[96.5vw] bg-gradient-to-r from-[#FFFCF8] via-[#5B5B5A] to-[#2C2C2C] rounded-lg">
          <div className="bg-[#090909] p-8 md:p-10 rounded-lg">
            <h3 className="text-[#EAE2C3] font-NanumMyeongjo text-3xl md:text-[48px] leading-tight mb-4">
              Catalyzing the <span className="text-[#C09462]">Future</span> of
              Technology and Capital World
            </h3>
            <p className="text-[#818181] text-lg md:text-2xl font-light font-Switzer mx-auto">
              MIF empowers founders, fuels transformative ventures, and
              redefines how real-world value converges with digital finance
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
